var _circle, _circle2, _ellipse, _ellipse2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgProfile8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#C0E9D0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.6757,
    cy: 25.6805,
    r: 15.2757,
    fill: "#FFF3F1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9885,
    cy: 28.8415,
    rx: 1.0535,
    ry: 1.58025,
    fill: "#262626"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.4165,
    cy: 28.8415,
    rx: 1.0535,
    ry: 1.58025,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3095 32.5288H23.8321C23.8321 33.5823 24.6222 34.3724 26.2025 34.3724C27.6923 34.3724 28.2217 33.2311 28.3095 32.5288Z",
    fill: "#F09387"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8718 10.4054C14.2617 10.6358 10.802 19.8869 10.4 24.6276H21.2538L21.6558 19.7515H23.2638L23.6658 24.2213H28.0877L28.4897 19.7515H30.0977L30.4997 24.2213H40.9515C40.4247 19.36 37.0008 10.1421 24.8718 10.4054Z",
    fill: "#736B67"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfile8);
export default __webpack_public_path__ + "static/media/img_profile_8.ff610bf869a8159eaf8650930ac9d07e.svg";
export { ForwardRef as ReactComponent };